import { Phone, Mail, MapPin } from "lucide-react";
import logo from "@/assets/lvm-logo.png";
import { COMPANY } from "@/data/site";

const CONTACTS = [
  {
    icon: Phone,
    label: "Call Us",
    value: COMPANY.phone,
    href: COMPANY.phoneHref,
    testid: "contact-phone",
  },
  {
    icon: Mail,
    label: "Email Us",
    value: COMPANY.email,
    href: COMPANY.emailHref,
    testid: "contact-email",
  },
  {
    icon: MapPin,
    label: "Location",
    value: COMPANY.location,
    href: null,
    testid: "contact-location",
  },
];

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-navy-950 pt-24 sm:pt-32"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-8">
        <div className="border-t border-navy-700 pt-16">
          <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-brand-light mb-4">
            Get In Touch
          </p>
          <h2 className="font-display font-black uppercase text-white text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9]">
            Let's Build
            <br />
            <span className="text-brand-light">Together.</span>
          </h2>
          <p className="mt-6 text-lg text-zinc-300 max-w-2xl">
            Ready to start your project? Reach out for a free estimate — we'll
            walk you through the process and get the job done right.
          </p>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 border-t border-l border-navy-700">
            {CONTACTS.map((c) => {
              const Icon = c.icon;
              const inner = (
                <div className="flex flex-col gap-3 p-8 border-r border-b border-navy-700 h-full hover:bg-navy-900 transition-colors">
                  <Icon className="w-8 h-8 text-brand-light" strokeWidth={1.5} />
                  <span className="font-display text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
                    {c.label}
                  </span>
                  <span className="text-lg sm:text-xl font-semibold text-white break-words">
                    {c.value}
                  </span>
                </div>
              );
              return c.href ? (
                <a key={c.label} href={c.href} data-testid={c.testid}>
                  {inner}
                </a>
              ) : (
                <div key={c.label} data-testid={c.testid}>
                  {inner}
                </div>
              );
            })}
          </div>

          <div className="mt-10">
            <a
              href={COMPANY.phoneHref}
              data-testid="contact-call-button"
              className="inline-flex items-center justify-center gap-3 bg-brand hover:bg-brand-dark text-navy-950 font-display font-bold uppercase tracking-wide text-base px-10 py-5 transition-colors"
            >
              <Phone className="w-5 h-5" />
              Call {COMPANY.phone}
            </a>
          </div>
        </div>

        <footer className="mt-20 border-t border-navy-700 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img
              src={logo}
              alt="LVM Drywall LLC logo"
              className="h-10 w-auto rounded-sm"
            />
          </div>
          <p className="text-sm text-zinc-500 text-center sm:text-right">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved. ·
            Owner: {COMPANY.owner}
          </p>
        </footer>
      </div>
    </section>
  );
};
